import * as IMAGE from '../../lib/image/event/EventBlogImages';
import * as PATH from '../../lib/routes/path';

const ID_BLOG = 'blog';
const PERIOD_BLOG = {
  startDate: '2024-06-01T00:00:00',
  endDate: '2024-06-30T00:00:00',
};

export const EVENT_HOME_BANNER_BLOG = {
  id: ID_BLOG,
  period: PERIOD_BLOG,
  image: IMAGE.HOME_BANNER_BLOG,
  path: PATH.BLOG,
};
